import {
    FETCH_LOYALTY_PROGRAM_BENEFITS,
    SAVE_BENEFIT,
    DELETE_BENEFIT,
    ISSUE_BENEFIT,
    UPDATE_ISSUED_BENEFIT,
    CLOSE_ISSUED_BENEFIT
} from '../types';
import api from '../api';

export const fetchLoyaltyProgramBenefits = (loyaltyProgramId) => {
    return {
        type: FETCH_LOYALTY_PROGRAM_BENEFITS,
        payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.getFull(),
    };
};

export const saveBenefit = (loyaltyProgramId, benefit) => {
    if (benefit.id) {
        return {
            type: SAVE_BENEFIT,
            payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.update(benefit),
            meta: { benefitId: benefit.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_BENEFIT,
            payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.create(benefit),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteBenefit = (loyaltyProgramId, benefitId) => {
    return {
        type: DELETE_BENEFIT,
        payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.delete(benefitId),
        meta: { benefitId, toastSuccess: true }
    };
};

export const saveIssue = (loyaltyProgramId, benefitId, issue) => {
    if (issue.id) {
        return {
            type: UPDATE_ISSUED_BENEFIT,
            payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.issues.update(benefitId, issue),
            meta: { benefitId, issueId: issue.id, toastSuccess: true }
        };
    } else {
        return {
            type: ISSUE_BENEFIT,
            payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.issue(benefitId, issue),
            meta: { benefitId, toastSuccess: true }
        };
    }
};

export const closeIssuedBenefit = (loyaltyProgramId, benefitId, issueId) => {
    return {
        type: CLOSE_ISSUED_BENEFIT,
        payload: api.loyaltyProgram.get(loyaltyProgramId).benefits.issues.closeIssue(benefitId, issueId),
        meta: { benefitId, issueId, toastSuccess: true }
    };
};